import React from 'react';
import CollapsibleTable from '../CollapsibleTable';

interface PersonaReaction {
  title: string;
  headers: string[];
  rows: Array<[string, string, number]>; // [persona_name, overall_effectiveness/score, thought_process]
}

interface PersonaReactionsProps {
  personaReactions: PersonaReaction;
  adTitle: string;
  isExporting?: boolean;
  className?: string;
}

const PersonaReactions: React.FC<PersonaReactionsProps> = ({
  personaReactions,
  isExporting = false,
  className = '',
}) => {
  // Convert data for CollapsibleTable
  // Check if headers already include # column
  const hasNumberColumn = personaReactions.headers[0] === '#';
  const headers = hasNumberColumn ? personaReactions.headers : ['#', ...personaReactions.headers];

  const tableData = {
    type: 'table' as const,
    title: personaReactions.title,
    headers: headers,
    data: personaReactions.rows.map((row, index) => {
      if (hasNumberColumn) {
        // If # column exists, headers are: [#, Profile Name, Overall Effectiveness, Thought Process]
        // But data rows are: [persona_name, thought_process, score]
        return {
          '#': (index + 1).toString(),
          [personaReactions.headers[1]]: row[0], // Profile Name
          [personaReactions.headers[2]]: row[2].toFixed(1), // Overall Effectiveness (score)
          [personaReactions.headers[3]]: row[1], // Thought Process
        };
      } else {
        // If no # column, headers are: [Profile Name, Overall Effectiveness, Thought Process]
        // But data rows are: [persona_name, thought_process, score]
        return {
          '#': (index + 1).toString(),
          [personaReactions.headers[0]]: row[0], // Profile Name
          [personaReactions.headers[1]]: row[2].toFixed(1), // Overall Effectiveness (score)
          [personaReactions.headers[2]]: row[1], // Thought Process
        };
      }
    }),
  };

  return (
    <div className={className}>
      {/* Persona Reactions Table */}
      <CollapsibleTable
        table={tableData}
        questionType="persona_reactions"
        isExporting={isExporting}
        maxInitialRows={3}
        showFullContent={true}
        showExportButtons={!isExporting}
      />
    </div>
  );
};

export default PersonaReactions;
